import React, {useContext} from 'react'
import { LinkContext } from '../provider/provider'


function Introduction() {
    
    const {data, loading} = useContext(LinkContext);

    

  return (
    <div>
        { loading ? <div>loading...</div> : 
        <div className='intro'>

            <img src={data.islogoalink ? data.logo : (process.env.PUBLIC_URL + data.logo)} className={ "logo " +(!data.imageislogo ? "circle": " ") + " " + (data.imageislogo && data.cropimagetosquare ? "square": " ")} alt="logo" />

           <p id='title'>{data.name}</p>
           <p id='desc'>{data.description}</p>
   </div>
    }
    </div>
  )
}

export default Introduction